import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class InterviewImageWithText extends Component {
  render() {
    return this.props.count % 2 ? (
      <div className={css(styles.container)}>
        <div className={css(styles.text_container)}>
          {this.props.text}
        </div>
        <div className={css(styles.image_container)}>
          <img src={this.props.image} className={css(styles.image)} />
        </div>
      </div>
    ) : (
      <div className={css(styles.container)}>
        <div className={css(styles.image_container, styles.image_right)}>
          <img src={this.props.image} className={css(styles.image)} />
        </div>
        <div className={css(styles.text_container, styles.align_right)}>
          {this.props.text}
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    [Theme.mobile_query]: {
      flexDirection: 'column',
      margin: '0px auto',
      width: '100%',
    },
  },
  text_container: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontFamily: Theme.fontFamily,
    fontWeight: 'bold',
    position: 'relative',
    boxSizing: 'border-box',
    paddingTop: 120,
    paddingRight: 30,
    letterSpacing: 1,
    fontSize: 17,
    lineHeight: '24px',
  },
  align_right: {
    textAlign: 'right',
    [Theme.mobile_query]: {
      paddingTop: 0,
      marginBottom: 100,
    },
  },
  image_container: {
    flex: 1,
    position: 'relative',
    ':before': {
      position: 'absolute',
      display: 'block',
      top: '50%',
      left: '-50%',
      zIndex: 10,
      transform: 'translateY(-50%)',
      content: "' '",
      width: '100%',
      height: 4,
      backgroundColor: Theme.primary,
      transition: "all 120ms ease-in-out",
    },
    [Theme.mobile_query]: {
      marginBottom: 100,
      ':before': {
        display: 'none',
      },
    },
  },
  image_right: {
    ':before': {
      left: '50%',
    },
    [Theme.mobile_query]: {
      marginBottom: 0,
    },
  },
  image: {
    position: 'relative',
    maxWidth: '100%',
    margin: '50px auto',
  },
});



// WEBPACK FOOTER //
// ./src/components/InterviewImageWithText/index.js